import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { uploadProduct, getProducts, deleteProduct } from "../../../services/modules/Imagenes";

const ProductManager = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    price: "",
    imageFile: null,
  });

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const data = await getProducts();
      setProducts(data);
    } catch (error) {
      console.error("Error al cargar productos:", error);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({ ...prev, imageFile: file }));
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    const { name, description, price, imageFile } = formData;

    if (!name || !description || !price || !imageFile) {
      alert("Por favor, completa todos los campos.");
      return;
    }

    setLoading(true);
    try {
      await uploadProduct(formData);
      alert("Producto subido correctamente.");
      setFormData({ name: "", description: "", price: "", imageFile: null });
      fetchProducts();
    } catch (error) {
      console.error("Error al subir producto:", error);
      alert("Hubo un error al subir el producto.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id, imageUrl) => {
    try {
      await deleteProduct(id, imageUrl);
      alert("Producto eliminado.");
      fetchProducts();
    } catch (error) {
      console.error("Error al eliminar producto:", error);
      alert("Hubo un error al eliminar el producto.");
    }
  };

  return (
    <Box sx={{ maxWidth: 600, margin: "auto", padding: 4 }}>
      <Typography variant="h5" textAlign="center" marginBottom={3}>
        Gestión de Productos
      </Typography>

      <TextField
        fullWidth
        label="Nombre del Producto"
        name="name"
        value={formData.name}
        onChange={handleInputChange}
        margin="normal"
      />
      <TextField
        fullWidth
        label="Descripción"
        name="description"
        value={formData.description}
        onChange={handleInputChange}
        margin="normal"
        multiline
        rows={3}
      />
      <TextField
        fullWidth
        label="Precio"
        name="price"
        type="number"
        value={formData.price}
        onChange={handleInputChange}
        margin="normal"
      />
      <Button variant="contained" component="label" sx={{ marginBottom: 2 }}>
        Seleccionar Imagen
        <input type="file" hidden onChange={handleFileChange} />
      </Button>
      {formData.imageFile && (
        <Typography variant="body2" marginBottom={2}>
          Archivo seleccionado: {formData.imageFile.name}
        </Typography>
      )}
      <Button
        variant="contained"
        color="primary"
        fullWidth
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? <CircularProgress size={24} /> : "Subir Producto"}
      </Button>

      <TableContainer sx={{ marginTop: 4 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nombre</TableCell>
              <TableCell>Descripción</TableCell>
              <TableCell>Precio</TableCell>
              <TableCell>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {products.map((product) => (
              <TableRow key={product.id}>
                <TableCell>{product.name}</TableCell>
                <TableCell>{product.description}</TableCell>
                <TableCell>${product.price}</TableCell>
                <TableCell>
                  <IconButton onClick={() => handleDelete(product.id, product.imageUrl)}>
                    <DeleteIcon />
                  </IconButton>
                  <IconButton>
                    <EditIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ProductManager;
